<!--
 * @Author: Jason
 * @Date: 2019-08-01 12:38:07
 * @version:
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 16:31:53
 * @Descripttion:
 -->
<template>
    <div>
        <v-head :isShowBack="$route.meta.isShowIcon" >服务细则</v-head>
        <div class="mt">
          <h2>服务细则</h2>
          <ul v-if="isWxTencent">
              <li>1.活动时间：即日起至2023年10月31日。</li>
              <li>2.活动对象：农行晋通ETC信用卡持卡人。</li>
              <li>3.活动内容：农行晋通ETC信用卡客户当月累计消费满500元，次月可享1次“1元洗车”优惠权益；当月累计消费满1000元，次月可享2次。两档奖励不可叠加享受。农行晋通ETC信用卡客户首次签约农行ETC业务，次月亦可获赠1次“1元洗车”优惠权益。数量有限，先购先得。</li>
              <li>4.购券路径：关注“山西农行微银行”微信公众号-惠生活-1元洗车，进入“1元洗车”购券页面，输入办卡预留手机号码验证通过后，使用农行信用卡在线支付1元即可购得洗车券。本活动权益为当月达标，次月5个工作日内兑现，以农行短信通知为准。</li>
              <li>5.洗车券服务有效期自购买日起30天，成功购买的洗车券可在活动页面“我的订单”中查看。洗车券为全省通用券，无需预约，客户可查询适用门店，前往服务点展示券码享受相应服务。</li>
              <li>6.活动参与车辆限七座（含）以下非营运车辆使用，7座以上车辆需额外加收费用，具体费用标准以各网点实际情况为准，本次活动优惠不与商户店内其它优惠、促销、赠券同时享受；</li>
              <li>7.本活动适用于上海盛世大联汽车服务股份有限公司山西地区所有洗车服务合作门店，可在活动页面直接查询服务门店，如有门店搬迁、关闭等变更情况，银行不再另行通知持卡人；</li>
              <li>8.本活动优惠权益由上海盛世大联汽车服务股份有限公司提供并全权负责，如遇问题，请致电盛大汽车服务热线：<span class="color-blue" @click="toTel('4008881768')">400-888-1768</span>。</li>
            </ul>
            <ul v-else>
              <li>1、活动时间：即日起至2023年10月31日；</li>
              <li>2、活动对象：农行晋通ETC信用卡持卡人；</li>
              <li>3、收到洗车活动短信通知的客户，可关注“盛世大联汽车”微信公众号-“优惠活动”-“山西农行1元洗车”，支付1元，可领一张洗车券；</li>
              <li>4、晋通ETC信用卡客户当月累计消费满500元，次月可享1次“1元洗车”优惠权益；当月累计消费满1000元，次月可享2次；当月首次签约ETC业务，次月亦可获赠1次。每卡每月至多可享3次“1元洗车”优惠权益。数量有限，先购先得。洗车券为省内通用券，可通过查询前去服务门店，并展示服务二维码享受该服务。</li>
              <li>5、洗车券服务有效期自购买日起30天，成功购买的洗车券可在活动页面中“我的订单”中查看，活动门店验证后方可享受服务，无需预约；</li>
              <li>6、活动参与车辆限七座（含）以下非营运车辆使用，7座以上车辆需额外加收费用，具体费用标准以各网点实际情况为准，本次活动优惠不与商户店内其它优惠、促销、赠券同时享受；</li>
              <li>7、本活动适用于上海盛世大联汽车服务股份有限公司山西地区所有洗车服务合作门店，可在活动页面直接查询服务门店，如有门店搬迁、关闭等变更情况，银行不再另行通知持卡人；</li>
              <li>8、本活动优惠权益由上海盛世大联汽车服务股份有限公司提供并全权负责，如遇问题，请致电盛大汽车服务热线：<span class="color-blue" @click="toTel('4008881768')">400-888-1768</span>。</li>
            </ul>
        </div>

        <div class="order-btn-list">
            <div @click="goBack()">确认</div>
        </div>


    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import vHead from "@/components/vHead.vue";
import { GetOrderQuery } from "@/api/order.js";
import { ls,ISWX } from "@/assets/js/utils.js";
export default {
    components: {
      vHead,
      QrcodeVue
    },

    data() {
        return {
          qrcodeSize: 160,
          orderInfo:{},
          headTille:"支付成功",
          TkStatus:true,
          isWxTencent:false
        };
    },
    mounted(){
      // let _ = this
      document.body.style.backgroundColor = '#fff'
    },
    created(){
      if (this.$route.query) {
        this.isWxTencent = this.$route.query.isWxTencent
      }
    },
    methods:{
      toRouter(val){
        let _ = this
        if(val == '/home'){
          _.$router.replace(val)
        }else{
          _.$router.push(val)
        }

      },
      goBack(){
        this.$router.go(-1)
      }
    }
}
</script>
<style lang="scss" scoped>
.order-tip{
  text-align: center;
  margin-top:1.6667vw;
}
.order-title{
  text-align: center;
  font-size: 6vw;
}
.mt{
  padding: 0 20px 50px;
  h2{
    height: 35px;line-height: 35px;font-size: 16px;
  }
  ul{
    li{
      margin-bottom: 10px;line-height: 20px;
    }
  }
}
  .order-btn-list{
    position: fixed;bottom: 0;height: 45px;line-height: 45px;text-align: center;background: #16a085;width: 100%;font-size: 17px;color: #fff;
  }

</style>


